module.exports = __webpack_public_path__ + "static/media/TRIAL 1 if-both-correct.6e562015.mp3";